import React, { useCallback } from 'react'
import MediaList from 'components/partials/MediaList'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import Label from 'components/Label'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function ResearchProjectTemplate({ ...doc }) {
  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <ResearchProjectTable {...doc} />
      ) : (
        <ResearchProjectTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

function ResearchProjectTable({
  title,
  preamble_cutoff,
  url,
  _click,
  research_areas,
  __research_type_short__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);

  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className='media'>
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
            <Description text={preamble_cutoff} modifierClasses="u-mt-25" />
          </MediaContent>
        </div>
      </td>
      <td>
        <Description text={__research_type_short__} />
      </td>
      <td />
      <td>
        <Description text={[].concat(research_areas).join(', ')} />
      </td>
    </tr>
  )
}
function ResearchProjectTeaser({
  title,
  preamble_cutoff,
  url,
  _click,
  research_areas,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <Label
          modifierClasses='u-font-weight-700 u-mt-25'
          text={[].concat(research_areas).join(', ')}
        />
        <Description text={preamble_cutoff} modifierClasses="u-mt-25" />
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}
export default ResearchProjectTemplate
